import type { CalendarAccess } from '@easyflow/shared';

type CalendarWriteAction = 'create' | 'edit' | 'delete';
interface CalendarParticipant {
  user_id?: string | null;
  assigned_to_id?: string | null;
}

/** Consume the server projection; observers/AI visibility never grants writes. */
export function canWriteCalendarObject(
  access: CalendarAccess | null,
  object: CalendarParticipant,
  action: CalendarWriteAction,
): boolean {
  if (!access?.canManage) return false;
  const ids = action === 'create' ? access.createUserIds
    : action === 'edit' ? access.editUserIds : access.deleteUserIds;
  return ids === null || [object.user_id, object.assigned_to_id]
    .some(id => typeof id === 'string' && ids?.includes(id) === true);
}
